import _ from 'lodash';

import {
  CHANGE_DASHBOARD_EDITING_STATE,
  DASHBOARD_REQUEST_FAILURE,
  DELETE_DASHBOARD_PART,
  EDIT_DASHBOARD_TAB,
  EDIT_DASHBOARD_TAB_CLOSE,
  FETCH_DASHBOARD_CONFIG_SUCCESS,
  SAVE_DASHBOARD_CONFIG_SUCCESS,
  SET_DASHBOARD_PENDING,
  UPDATE_DASHBOARD_PART,
} from '../actions/DashboardConfigActions';

const initialState = {
  personalization: null,
  error: '',
  pending: false,
  code: null,
  rowId: null,
  prevConfig: null,
  tabEdit: { id: null },
  globalDefaultDashboard: false,
  userSpecificDashboard: false,
  hasAdminRights: false,
};

export default (state = initialState, action) => {
  const { personalization } = state;
  const active = _.get(personalization, 'active');

  switch (action.type) {
    case SET_DASHBOARD_PENDING:
      return {
        ...state,
        pending: action.payload.flag,
      };

    case DASHBOARD_REQUEST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action?.error,
      };

    case FETCH_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        pending: false,
        code: action.payload.code,
        rowId: action.payload.rowId,
        prevConfig: action.payload.prevConfig,
        personalization: JSON.parse(action.payload.config),
        hasAdminRights: action.payload.hasAdminRights,
        ...action.payload.dashboardsInfo,
      };

    case CHANGE_DASHBOARD_EDITING_STATE:
      return {
        ...state,
        isEditGlobal: action.isEditGlobal,
        personalization: {
          ...personalization,
          mode: action.value,
          draft:
            action.value !== 'general'
              ? personalization?.draft || { ...personalization?.config }
              : null,
        },
      };

    case DELETE_DASHBOARD_PART:
      return _.set(
        _.cloneDeep(state),
        ['personalization', 'draft', active, action.id, 'hidden'],
        true
      );

    case UPDATE_DASHBOARD_PART: {
      const mode = _.get(state, ['personalization', 'mode']);
      const config = mode !== 'general' ? 'draft' : 'config';
      const { part, tab } = action.payload.updates;
      const partPath = ['personalization', config, active, part.id];
      const partFromState = _.get(state, partPath);
      const partUpdates = _.merge({}, partFromState, part);

      const updatedState = _.cloneDeep(state);
      _.set(updatedState, partPath, partUpdates);

      if (!tab) {
        return updatedState;
      }

      const tabIndex = personalization[config][active][part.id].tabs.findIndex(
        (t) => t.id === tab.id
      );
      const tabPath = ['personalization', config, active, part.id, 'tabs', tabIndex];
      const tabFromState = _.get(updatedState, tabPath);
      const tabUpdates = _.merge({}, tabFromState, tab);

      _.set(updatedState, tabPath, tabUpdates);

      return updatedState;
    }

    case SAVE_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...initialState,
        userSpecificDashboard: state.userSpecificDashboard,
        globalDefaultDashboard: state.globalDefaultDashboard,
        personalization: {
          mode: 'general',
          active,
          config: {
            ...state.personalization.config,
            [active]: action.payload.config,
          },
        },
        code: action.payload.code,
        rowId: action.payload.rowId,
      };

    case EDIT_DASHBOARD_TAB:
      return {
        ...state,
        tabEdit: action.payload,
      };

    case EDIT_DASHBOARD_TAB_CLOSE:
      return {
        ...state,
        tabEdit: { id: null },
      };

    default:
      return state;
  }
};
